import React, { useState, useEffect } from 'react';

const InstrumentForm = ({ instrument, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    Nombre: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (instrument) {
      setFormData(instrument);
    }
  }, [instrument]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    if (name === 'Nombre' && !value.trim()) {
      setErrors(prev => ({ ...prev, Nombre: 'Nombre es requerido' }));
    } else {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const newErrors = {};
    
    if (!formData.Nombre.trim()) newErrors.Nombre = 'Nombre es requerido';
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-4">
        {/* Nombre */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Nombre del Instrumento *
          </label>
          <input
            type="text"
            name="Nombre"
            value={formData.Nombre}
            onChange={handleChange}
            className={`mt-1 block w-full border rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm ${
              errors.Nombre ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-primary-500 focus:ring-primary-500'
            }`}
            placeholder="Ej: Piano, Guitarra, Violín..."
          />
          {errors.Nombre && (
            <p className="mt-1 text-sm text-red-600">{errors.Nombre}</p>
          )}
        </div>
      </div>

      {/* Botones */}
      <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          {instrument ? 'Actualizar' : 'Guardar'}
        </button>
      </div>
    </form>
  );
};

export default InstrumentForm;